import { render, staticRenderFns } from "./SimpleMessageBox.vue?vue&type=template&id=4bf2ba5c&scoped=true&"
import script from "./SimpleMessageBox.vue?vue&type=script&lang=ts&"
export * from "./SimpleMessageBox.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleMessageBox.vue?vue&type=style&index=0&id=4bf2ba5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2ba5c",
  null
  
)

export default component.exports